import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";
import { Box, FormHelperText } from "@mui/material";

const jsonExtensions = [json()];
const basicSetupOptions = { closeBrackets: true, indentOnInput: true };

type JsonCodeEditorProps = {
	id?: string;
	label?: string;
	value: string;
	onChange?: (value: string) => void;
	helperText?: string;
	placeholder?: string;
	minHeight?: string;
	readOnly?: boolean;
	error?: boolean;
};

export default function JsonCodeEditor({
	id,
	label,
	value,
	onChange,
	helperText,
	placeholder,
	minHeight = "120px",
	readOnly = false,
	error = false,
}: JsonCodeEditorProps) {
	return (
		<Box>
			{label && (
				<Box
					component="label"
					htmlFor={id}
					sx={{
						display: "block",
						fontSize: "0.75rem",
						color: "text.secondary",
						marginBottom: 0.5,
					}}
				>
					{label}
				</Box>
			)}
			<Box
				sx={{
					border: "1px solid",
					borderColor: error ? "error.main" : "divider",
					borderRadius: 1,
					overflow: "hidden",
				}}
			>
				<CodeMirror
					id={id}
					value={value}
					theme="light"
					extensions={jsonExtensions}
					basicSetup={basicSetupOptions}
					minHeight={minHeight}
					placeholder={placeholder}
					readOnly={readOnly}
					onChange={onChange}
				/>
			</Box>
			{helperText && (
				<FormHelperText error={error}>{helperText}</FormHelperText>
			)}
		</Box>
	);
}
